import React, { useContext } from 'react';
import { CustomersContext, ICustomersContext } from '../../../customersState/customersContext';
import { SearchFieldNew } from 'components/SearchField/SearchFieldNew';

export const Search: React.FC = () => {
	const { changeSearchString, searchString, customers } = useContext<ICustomersContext>(CustomersContext);

	return (
		<SearchFieldNew
			onChangeSelectSearchString={changeSearchString}
			searchString={searchString}
			delay={customers.customerCount ? 800 : undefined}
			size="large"
		/>
	);
};
